import { useTranslation } from "react-i18next"

import MyModal from "@/components/MyModal/MyModal"
import { MODALS } from "@/constants/modals"

import RoundsNotesModal from "../Feedbacks/NotesModal/RoundsNotesModal"
import SkillsModal from "../Profile/Skills/SkillsModal"
import SocialLinksModal from "../Profile/SocialLinks/SocialLinksModal"
import VideoModal from "./VideoModal"

export default function CourseModals() {
  const { t } = useTranslation()
  return (
    <>
      <MyModal
        size="lg"
        modalName={MODALS.enrolledRounds.notes}
        title={t("courseModalsTitles.roundNotes")}
      >
        <RoundsNotesModal />
      </MyModal>
      <MyModal
        modalName={MODALS.lecture.video}
        title={t("courseModalsTitles.video")}
      >
        <VideoModal />
      </MyModal>
      <MyModal
        modalName={MODALS.profile.editSocialLinks}
        title={t("courseModalsTitles.editSocialLinks")}
      >
        <SocialLinksModal />
      </MyModal>
      <MyModal
        modalName={MODALS.skills.edit}
        title={t("courseModalsTitles.editSkills")}
      >
        <SkillsModal />
      </MyModal>
    </>
  )
}
